import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar, gridClasses } from "@mui/x-data-grid";
import moment from "moment";
import reportApi from "../../services/reportapi";
import Loader from "../loader/loader";
import DynamicBreadcrumb from "../header/breadcrumb";
import branchApi from "../../services/branchapi";

const DeliveryExecutivePerformance = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [branches, setBranches] = useState([]);
    const [filters, setFilters] = useState({
        from_date: moment().format("YYYY-MM-DD"),
        to_date: moment().format("YYYY-MM-DD"),
        branch_id: ""
    });
    const [loaderVisible, setLoaderVisible] = useState(false);

    const updateFilters = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    const fetchData = async () => {
        setLoaderVisible(true);
        setLoading(true);
        try {
            const payload = {
                branchId: filters.branch_id,
                from_date: filters.from_date,
                to_date: filters.to_date
            };

            const response = await reportApi.getDeliveryExecutivePerformance(payload);
            setRows(response.data || []);
        } catch (err) {
            console.error("Error fetching delivery executive performance:", err);
        } finally {
            setLoaderVisible(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const branchData = await branchApi.getAllBranches({
                    limit: 100,
                    page: 0,
                    status: 1,
                    sortModel: [{ field: "branchName", sort: "asc" }],
                });
                setBranches(branchData.data.result || []);
            } catch (error) {
                console.error("Error fetching branches:", error);
            }
        };
        fetchBranches();
    }, []);

    const columns = [
        { field: "emp_name", headerName: "Executive", flex: 1 },
        { field: "emp_mob", headerName: "Mobile", flex: 1 },
        { field: "total", headerName: "Total Delivered", flex: 1 },
        { field: "ontime", headerName: "On-Time", flex: 1 },
        { field: "earlier", headerName: "Early", flex: 1 },
        { field: "delayed", headerName: "Delayed", flex: 1 },
    ];

    const pathArray = [{ name: "Delivery Executive Performance", url: null }];

    return (
        <Container className="mt-4 mb-4">
            <DynamicBreadcrumb pathArray={pathArray} />
            <h5>Delivery Executive Performance</h5>
            <Form className="mb-3">
                <Row>
                    <Col md={3}>
                        <Form.Label>Branch</Form.Label>
                        <Form.Select
                            value={filters.branch_id}
                            onChange={(e) => updateFilters("branch_id", e.target.value)}
                        >
                            <option value="">All Branches</option>
                            {branches.map(branch => (
                                <option key={branch.branchId} value={branch.branchId}>
                                    {branch.branchName}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                    <Col md={3}>
                        <Form.Label>From Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={filters.from_date}
                            onChange={(e) => updateFilters("from_date", e.target.value)}
                        />
                    </Col>
                    <Col md={3}>
                        <Form.Label>To Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={filters.to_date}
                            onChange={(e) => updateFilters("to_date", e.target.value)}
                        />
                    </Col>
                    <Col md={3} className="d-flex align-items-end">
                        <Button variant="primary" onClick={fetchData}>
                            Filter
                        </Button>
                    </Col>
                </Row>
            </Form>

            {loaderVisible && <Loader />}

            <Box>
                <DataGrid
                    rows={rows.map((row, index) => ({ id: index + 1, ...row }))}
                    columns={columns}
                    getRowHeight={() => "auto"}
                    loading={loading}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            csvOptions: {
                                fileName: `DeliveryExecutivePerformance_${moment().format("YYYYMMDD_HHmmss")}`,
                                utf8WithBom: true
                            },
                            printOptions: { disableToolbarButton: true },
                        },
                    }}
                    sx={{
                        [`& .${gridClasses.cell}`]: { py: 1 },
                    }}
                />
            </Box>
        </Container>
    );
};

export default DeliveryExecutivePerformance;